import React, { InputHTMLAttributes } from 'react';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
}

export const Input: React.FC<InputProps> = ({
  label,
  error,
  className = '',
  ...props
}) => {
  return (
    <div className="form-group">
      {label && <label className="form-label">{label}</label>}
      <input className={`input ${className}`.trim()} {...props} />
      {error && (
        <span style={{ color: 'var(--accent-danger)', fontSize: 'var(--font-size-xs)', marginTop: 'var(--spacing-xs)' }}>
          {error}
        </span>
      )}
    </div>
  );
};

interface TextAreaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
}

export const TextArea: React.FC<TextAreaProps> = ({
  label,
  error,
  className = '',
  ...props
}) => {
  return (
    <div className="form-group">
      {label && <label className="form-label">{label}</label>}
      <textarea className={`textarea ${className}`.trim()} {...props} />
      {error && (
        <span style={{ color: 'var(--accent-danger)', fontSize: 'var(--font-size-xs)', marginTop: 'var(--spacing-xs)' }}>
          {error}
        </span>
      )}
    </div>
  );
};

interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  error?: string;
  options: Array<{ value: string; label: string }>;
}

export const Select: React.FC<SelectProps> = ({
  label,
  error,
  options,
  className = '',
  ...props
}) => {
  return (
    <div className="form-group">
      {label && <label className="form-label">{label}</label>}
      <select className={`select ${className}`.trim()} {...props}>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      {error && (
        <span style={{ color: 'var(--accent-danger)', fontSize: 'var(--font-size-xs)', marginTop: 'var(--spacing-xs)' }}>
          {error}
        </span>
      )}
    </div>
  );
};
